import { Flex, HStack, Text } from '@chakra-ui/react'
import { SelectedMessage, ThreadMessageReplyTo } from '@hb/shared'

import { useThreadView } from '@hb/react'
import { AttachedFiles } from './AttachedFiles'

export const MessageReplyToView = ({
  replyTo,
  scrollToMessage,
}: {
  replyTo: ThreadMessageReplyTo
  scrollToMessage: (message: SelectedMessage) => boolean
}) => {
  const {
    messages: { selectMessage },
  } = useThreadView()

  const numAttachedFiles = Object.keys(replyTo.message.attachedFiles ?? {}).length
  return (
    <Flex pb={2} w="100%">
      <Flex
        cursor="pointer"
        onClick={() =>
          scrollToMessage({
            messageGroupId: replyTo.messageGroupId,
            messageId: replyTo.messageId,
            selectedOn: Date.now(),
            messageGroupCreatedOn: replyTo.messageGroupCreatedOn,
          }) ||
          selectMessage({
            messageGroupId: replyTo.messageGroupId,
            messageId: replyTo.messageId,
            selectedOn: Date.now(),
            messageGroupCreatedOn: replyTo.messageGroupCreatedOn,
          })
        }
        boxShadow="1px 1px 3px #00000066"
        w="100%"
        borderRadius={4}
        bg="gray.50"
        p={1}
        px={2}
        flexDir="column">
        <HStack w="100%">
          <Text flex={1} whiteSpace="nowrap" fontSize="sm" color="gray.500">
            {replyTo.authorFirstName} {replyTo.authorLastName}:
          </Text>
          {numAttachedFiles ? (
            <AttachedFiles
              messageGroupId={replyTo.messageGroupId}
              messageId={replyTo.messageId}
              attachedFiles={replyTo.message.attachedFiles}
              isPreview
            />
          ) : null}
        </HStack>
        <Text fontSize="sm" lineHeight={1.2} color="gray.800" fontFamily="hero-new" noOfLines={2}>
          {replyTo.message.text}
        </Text>
      </Flex>
    </Flex>
  )
}
